<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        config-module="410"
        :is-append-query="true"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <template slot="operations">
          <el-button
            :disabled="!selectedRow"
            no="new"
            type="primary"
            @click="toLook()"
          >{{ $t('common.btn.look') }}</el-button>
          <el-button type="primary" @click="toAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button
            :disabled="!editBtnEnabled"
            no="edit"
            type="primary"
            @click="toEdit"
          >{{ $t('common.btn.edit') }}</el-button>
          <el-button
            :disabled="!selectedRow"
            no="copy"
            type="primary"
            @click="toCopy"
          >{{ $t('SeaExport.Copy') }}</el-button>
          <el-button
            :disabled="rowData.length===0"
            no="delete"
            type="danger"
            @click="toDelete"
          >{{ $t('SeaExport.Delete') }}</el-button>
          <template v-if="forecastApproval">
            <!--提交-->
            <el-button v-show="$checkPermission(['button_Order_submit'])" type="primary" no="submit" @click="submitHanlder">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
            <!--撤回-->
            <el-button v-show="$checkPermission(['button_Order_revoke'])" type="primary" no="revoke" @click="revokeHanlder">{{ $t('Message.Withdraw') }}</el-button>
          </template>
          <!--协作状态: 审核通过-->
          <el-button
            v-show="$checkPermission(['button_Order_accept']) && useOrderCenterMode && approveCooperationBusiness"
            type="primary"
            no="accept"
            @click="acceptHandler(0)"
          >
            {{ $t('SeaExport.PassAudit') }}
          </el-button>
          <!--协作状态: 拒绝-->
          <el-button
            v-show="$checkPermission(['button_Order_reject']) && useOrderCenterMode && approveCooperationBusiness"
            type="primary"
            no="reject"
            @click="rejectHandler(0)"
          >
            {{ $t('SeaExport.Refuse') }}
          </el-button>
          <el-button
            v-permission="['button_Order_aiReportTransfer']"
            :disabled="!selectedRow"
            type="primary"
            no="forecastApproval"
            @click="forecastApproval ? forecastConvertNormal() : toConvertNormal()"
          >{{ $t('SeaExport.RegularBusiness') }}</el-button>
          <div style="float: right;color: #6666CC;line-height: 16px;">{{ $t('queryJob.OrangeWorkingDaysFromETA') }}<br>{{ $t('queryJob.RedWorkingDaysFromETA') }}</div>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height: 350px;">
        <cargo-ag-grid-wrapper
          config-module="210002"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          style="width: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="210002"
          :total="total"
          :page-count="pageCount"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="toQuery"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
    <!--拒绝 -->
    <reject-dialog
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
  </div>
</template>

<script>
import moment from 'moment'
import jobDetailIcon from '@/assets/job-detail.png'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage, stopBubble, deepCopy, getConfigBoolValue, sleep } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { advancedQuery } from '@/api/AirImport/aiBooking'
import { batchDeleteJob, updateJobs, batchUpdatePreVerifyState } from '@/api/booking/job'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import rejectDialog from '@/views/cargo/v0/SeaImport/components/Prediction/opVerifyFrameRejectDialog'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { cache, cacheName } from '@/utils/cacheManager'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'

export default {
  name: 'AiOrderTreeGrid',
  components: { cargoAgGridWrapper, searchItem, cargoTemplateSelectorDialog, cooperationVerifyDialog, rejectDialog },
  props: {
    context: { type: Object, required: true },
    useOrderCenterMode: { type: Boolean, default: false },
    orderCenterBranch: { type: Boolean, default: false },
    approveCooperationBusiness: { type: Boolean, default: false }
  },
  data() {
    return {
      notRefresh: false,
      appendQuery: false, // 追加查询
      loading: null,
      forecastApproval: false, // 是否用预报审批流程
      customSearchItems: [],
      oldIsAdvanceQuery: false, // 记录上一次操作是否为高级查询
      isAdvancedQuery: false, // 是否为高级查询
      simpleFilter: {
        conditions: [],
        branchId: 0
      },
      complexFilter: {
        conditions: [],
        branchId: 0
      },
      pageNum: 1,
      pageSize: 50,
      total: 0,
      pageCount: 0,
      rowData: [],
      selectedNode: null,
      gridApi: null,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      airMblDisplayStyle: false, // 空运主单号格式
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        jobUuids: [],
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      },
      rejectWindow: {
        visible: false,
        jobNo: '',
        rejectCallBack: this.rejectCooperateCallBackHandler
      }
    }
  },
  computed: {
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    },
    columnDefs() {
      const result = [
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Mbl2'),
          field: 'mbl',
          enableRowGroup: true,
          width: 150,
          cellRenderer: params => ColumnUtils.mawbNoLabelFun(params.value, this.airMblDisplayStyle)
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortOfLoadingAgent'),
          field: 'loadingAgentId',
          enableRowGroup: true,
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          enableRowGroup: true,
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierId',
          enableRowGroup: true,
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.FlightNo'),
          field: 'voyageFlight',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortOfLoadingAI'),
          field: 'loadingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          },
          width: 180
        }, {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'dischargingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          },
          width: 130
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityContract',
          enableRowGroup: true,
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightContract',
          enableRowGroup: true,
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageContract',
          enableRowGroup: true,
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.BusinessType'),
          field: 'operateType',
          enableRowGroup: true,
          width: 180,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
            }
            return ''
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('SeaExport.BusinessStatus'),
          field: 'jobState',
          width: 150,
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.getJobStateForBlock(params.data)
            }
            return ''
          },
          filter: false,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          }
        }, {
          headerName: this.$t('SeaExport.ExpectedArrivalDate'),
          field: 'eta',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          enableRowGroup: true,
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlinePerson2'),
          field: 'planner',
          enableRowGroup: true,
          width: 150,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          enableRowGroup: true,
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          colId: 'dc',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Creator'),
          field: 'createdBy',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.createdBy), 'chineseName')
            }
            return ''
          },
          width: 120
        },
        { headerName: this.$t('queryJob.totalIncome'), colId: 'income', field: 'income', width: 180,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('queryJob.totalCost'), colId: 'cost', field: 'cost', width: 180,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('FinanceManage.charge_profitAll'), colId: 'realProfit', field: 'realProfit', width: 180,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateStatus'),
          colId: 'cooperateStatus',
          field: 'cooperateStatus',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.cooperateStatusLabelFunc(Number(params.value))
          },
          hide: !this.useOrderCenterMode,
          width: 100, minWidth: 100
        }, {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: 'csrDepartment',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: 'dcDepartment',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          colId: 'plannerDepartment',
          field: 'plannerDepartment',
          width: 140,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          width: 180,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          width: 180,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        }
      ]
      if (this.forecastApproval) {
        result.push({
          headerName: this.$t('SeaExport.PreverifyStatus'),
          field: 'preverifyState',
          colId: 'preverifyState',
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPreverifyStateCN(Number(params.value) || 1)
          },
          width: 150
        })
        result.push({
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'bookingRefuseNote',
          field: 'bookingRefuseNote',
          enableRowGroup: true,
          width: 150,
          valueGetter: (params) => {
            if (params.data && params.data.preverifyState === 3 || params.data.preverifyState === 6) {
              return params.data.bookingRefuseNote
            }
            return ''
          }
        })
      }
      return result
    },
    editBtnEnabled() {
      if (!this.selectedRow) {
        return false
      }
      if (this.isCooperate(this.selectedRow.cooperateStatus)) return true
      if (this.forecastApproval) {
        return this.selectedRow.preverifyState === 3 || this.selectedRow.preverifyState === 4 || this.selectedRow.preverifyState === 6
      }
      return true
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await sleep(1000)
        this.forecastApproval = await getConfigBoolValue('ForecastApprovalAI')
        if (this.forecastApproval) {
          const searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'job.PREVERIFY_STATE'
          searchField.itemLabel = 'SeaExport.PreverifyStatus'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dataCacheKey = 'local_cache_SystemConstants$VERIFY_STATES'
          searchField.dataCacheKey = ''
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = SystemConstants.REMOTE_BOOKING_STATES
          this.customSearchItems = [searchField.formatObj2Json()]
        } else {
          this.customSearchItems = []
        }
        if (this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
          // 协作状态
          const searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'cooperate.COOPERATE_STATUS'
          searchField.itemLabel = 'CargoMsg.Cargo_CooperateStatus'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = Array.from(SystemConstants.COOPERATE_STATUS)
          this.customSearchItems.push(searchField.formatObj2Json())
        }
        // 委托单位
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': '',
          'tagValue': 'cmpIdx',
          'useSales': true
        }
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.itemName = 'job.CUSTOMER_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
        searchField.defaultSelected = 1
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())
      }
    }
  },
  created() {
    // 当前日期
    const today = DateUtils.formatStandardDate(new Date())
    // 扩展data
    Object.assign(this, {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
          }
        },
        onRowDataChanged: event => {
          /* 重置单选行 */
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = null
          if (nodes.length > 0) {
            event.api.setFocusedCell(0, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          this.toLook(event.data)
        },
        getRowStyle: params => {
          if (!params.data) {
            return {}
          }
          if (params.data.eta) {
            const days = DateUtils.getBetweenDays(today, DateUtils.formatStandardDate(params.data.eta))
            if (days > 0) {
              if (days <= 3) {
                return { background: 'red' }
              } else if (days <= 7) {
                return { background: 'orange' }
              }
            }
          }
          return {}
        },
        context: {
          componentParent: this
        }
      },
      documentManage: new DocumentManage()
    })
    this.queryLatelyTwoDayJob()
    this.preloadBasicData()
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showBusinessInfo', function() {
      self.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 查询最近两天（跳过周六日）编辑过的单子
    queryLatelyTwoDayJob() {
      const minDate = moment()
      switch (minDate.weekday()) {
        case 1: // 周日
          minDate.subtract(3, 'days')
          break
        case 2: // 周一
          minDate.subtract(4, 'days')
          break
        case 3: // 周二
          minDate.subtract(4, 'days')
          break
        default:
          minDate.subtract(2, 'days')
          break
      }
      const minDateStr = minDate.format('YYYY-MM-DD 00:00:00')
      this.toAdvancedQuery([
        new AdvancedSearchOption(null, 'job.MODIFIED_BY', this.context.user.userId).formatObj2Json(),
        new AdvancedSearchOption(null, 'job.DATE_MODIFIED', minDateStr, AdvancedSearchConsts.OPERATOR_GREATER.code).formatObj2Json()
      ])
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      if (this.filter.conditions.length === 0) {
        return
      }
      if (this.isAdvancedQuery !== this.oldIsAdvanceQuery) {
        this.pageNum = 1
        this.oldIsAdvanceQuery = this.isAdvancedQuery
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      let data
      if (typeof keyword !== 'undefined') {
        data = [
          new AdvancedSearchOption(null, 'job.JOB_NO', keyword, 'LIKE').formatObj2Json()
        ]
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        filter.conditions = this.handleConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(filter.conditions)
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      filter.appendQuery = this.appendQuery
      filter.requires = ['aiBookingVerify']
      filter.verifyModel = true
      this.loading = getLoading()
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(filter).then(res => {
        let results = res.data.list
        if (this.appendQuery) { // 追加查询数据去重
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
          this.total = results.length
        } else {
          this.pageNum = res.data.pageNum
          this.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
          this.pageCount = res.data.pages
        }
        this.rowData = results
      }).finally(() => {
        this.notRefresh = false
        this.loading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      data.push(new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        data.push(new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json())
      }
      // 预审状态
      const option = AdvancedSearchOption.removeOption('job.PREVERIFY_STATE', data)
      if (option) {
        if (option.value instanceof Array && option.value.includes(1)) {
          option.value.push(0)
        }
        data.push(option)
      }
      return data
    },
    // 业务编号右边放大镜图标点击事件处理
    showBusinessInfo(e) {
      stopBubble(e)
      this.templateSelectorDialog.ctx = new AirImportJob(this.selectedRow)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedRow.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 查看
    toLook(row) {
      this.$emit('look', row || this.selectedRow)
    },
    // 新增
    toAdd() {
      this.$emit('add')
    },
    // 编辑
    toEdit() {
      this.$emit('edit', this.selectedRow)
    },
    // 复制
    toCopy() {
      this.$emit('copy', this.selectedRow)
    },
    // 删除
    async toDelete() {
      if (this.isCooperate(this.selectedRow.cooperateStatus)) {
        this.$message.warning('[' + this.selectedRow.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
        return
      }
      if (this.selectedRow.jobState > -1) {
        this.$message.warning(this.$t('AirImport.ThisAlreadyAFormalBusiness'))
        return
      }
      this.$confirm(this.$t('queryJob.AreToDeleteTheBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(async() => {
        const rows = this.gridApi.getSelectedRows()
        const jobKeys = Array.from(rows, p => p.uuid)
        this.loading = getLoading()
        try {
          await batchDeleteJob({ jobKeys })
          await this.btachAllResultHandler()
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
        } finally {
          this.loading.close()
        }
      }).catch()
    },
    // 用于处理删除和业务转换返回结果
    async btachAllResultHandler() {
      const rows = this.gridApi.getSelectedRows()
      for (const row of rows) {
        const index = this.rowData.findIndex(p => p.uuid === row.uuid)
        if (index >= 0) {
          this.rowData.splice(index, 1)
        }
        if (row.lclMasterUuid) {
          const masterJob = this.rowData.find(p => p.uuid === row.lclMasterUuid)
          if (masterJob) {
            await new AirImportJob(masterJob).loadJobRelated({ job: true })
          }
        }
      }
    },
    submitHanlder() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      const keys = []
      for (const row of rows) {
        if (this.isCooperate(row.cooperateStatus)) {
          this.$message.warning('[' + row.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (row.preverifyState === 3 || row.preverifyState === 4 || row.preverifyState === 6) {
          keys.push(row.uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.success(this.$t('Message.SuccessfullySubmittedXBusinessOtherIgnore', { num: 0 }))
        return
      }
      const loading = getLoading4Cxt(this)
      batchUpdatePreVerifyState(keys, 1).then(res => {
        for (const item of this.rowData) {
          for (const newJob of res.data) {
            if (item.uuid === newJob.uuid) {
              item.version = newJob.version
              item.preverifyState = newJob.preverifyState
              break
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
        if (keys.length === rows.length) {
          this.$message.success(this.$t('Message.SuccessfullySubmittedXBusiness', { num: keys.length }))
        } else {
          this.$message.success(this.$t('Message.SuccessfullySubmittedXBusinessOtherIgnore', { num: keys.length }))
        }
      }).finally(() => {
        loading.close()
      })
    },
    revokeHanlder() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      const keys = []
      for (const row of rows) {
        if (this.isCooperate(row.cooperateStatus)) {
          this.$message.warning('[' + row.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (row.preverifyState === 0 || row.preverifyState === 1) {
          keys.push(row.uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.success(this.$t('Message.SuccessfullyRevokedXBusinessOtherIgnore', { num: 0 }))
        return
      }
      const loading = getLoading4Cxt(this)
      batchUpdatePreVerifyState(keys, 4).then(res => {
        for (const item of this.rowData) {
          for (const newJob of res.data) {
            if (item.uuid === newJob.uuid) {
              item.version = newJob.version
              item.preverifyState = newJob.preverifyState
              break
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
        if (keys.length === rows.length) {
          this.$message.success(this.$t('Message.SuccessfullyRevokedXBusiness', { num: keys.length }))
        } else {
          this.$message.success(this.$t('Message.SuccessfullyRevokedXBusinessOtherIgnore', { num: keys.length }))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 预报审批转正式业务
    async forecastConvertNormal() {
      const rows = this.gridApi.getSelectedRows()
      const jobs = []
      for (const row of rows) {
        if (this.isCooperate(row.cooperateStatus)) {
          this.$message.warning('[' + row.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (row.preverifyState === 0 || row.preverifyState === 1) {
          jobs.push({ ...row, preverifyState: 2, jobState: 0, preverifier: this.$store.getters.userId, preverifyDate: new Date() })
        }
      }
      if (jobs.length === 0) {
        this.$message.success(this.$t('Message.SuccessfullyConvertRealXBusinessOtherIgnore', { num: 0 }))
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        await updateJobs(jobs, { selectiveType: 'preverifyState,preverifier,preverifyDate,jobState', calculateEstimate: true })
        await this.btachAllResultHandler()
        if (jobs.length === rows.length) {
          this.$message.success(this.$t('Message.SuccessfullyConvertRealXBusiness', { num: jobs.length }))
        } else {
          this.$message.success(this.$t('Message.SuccessfullyConvertRealXBusinessOtherIgnore', { num: jobs.length }))
        }
      } finally {
        loading.close()
      }
    },
    toConvertNormal() {
      if (this.isCooperate(this.selectedRow.cooperateStatus)) {
        this.$message.warning('[' + this.selectedRow.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
        return
      }
      if (this.selectedRow.jobState > -1) {
        this.$message.warning(this.$t('AirImport.ThisAlreadyAFormalBusiness'))
        return
      }
      this.$confirm(this.$t('queryJob.AreToConvertTheItem2'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(async() => {
        const rows = this.gridApi.getSelectedRows()
        const jobs = deepCopy(rows)
        for (const item of jobs) {
          item.jobState = 0
          item.preverifier = this.$store.getters.userId
          item.preverifyDate = new Date()
          item.preverifyState = 2
        }
        this.loading = getLoading()
        try {
          await updateJobs(jobs, { selectiveType: 'preverifyState,preverifier,preverifyDate,jobState', calculateEstimate: true })
          await this.btachAllResultHandler()
          this.$message.success(this.$t('queryJob.ConversionSucceeded'))
        } finally {
          this.loading.close()
        }
      }).catch()
    },
    // 是否协作状态
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        return true
      }
      return false
    },
    // 协作状态: 审核通过
    acceptHandler(type) {
      const jobLists = this.gridApi.getSelectedRows()
      if (!jobLists || jobLists.length <= 0) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (jobLists.length > 50) {
        this.$message.warning(this.$t('SeaExport.BatchAuditBusinessTip'))
        return
      }
      const cooperateList = []
      for (const seaJob of jobLists) {
        if (this.isCooperate(seaJob.cooperateStatus)) { cooperateList.push(seaJob.uuid) }
      }
      if (cooperateList.length > 0) {
        if (cooperateList.length !== jobLists.length) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateReviewSeparately'))
          return
        }
        this.acceptCooperateHandler(type, cooperateList)
        return
      }
    },
    acceptCooperateHandler(type, cooperateList) {
      if (!cooperateList || cooperateList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuids = cooperateList
      this.cooperationVerifyDialog.jobUuid = this.selectedRow.uuid // 显示其中一笔
      const cooperate = {
        branchId: this.selectedRow.cooperateBranchId,
        opId: this.selectedRow.cooperateOpId,
        csrId: this.selectedRow.cooperateCsrId,
        overseaOp: this.selectedRow.cooperateOverseaOp,
        dcId: this.selectedRow.cooperateDcId,
        planner: this.selectedRow.cooperatePlanner,
        sales: this.selectedRow.cooperateSales,
        cargoSalesId: this.selectedRow.cooperateCargoSalesId,
        userDefinedRoleId1: this.selectedRow.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.selectedRow.cooperateUserDefinedRoleId2,
        businessType: this.selectedRow.cooperateBusinessTypeCode ? this.selectedRow.cooperateBusinessTypeCode.split(',') : []
      }
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuids: this.cooperationVerifyDialog.jobUuids, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectHandler(type) {
      this.rejectWindow.type = type
      if (!this.selectedRow) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.rejectWindow.jobNo = this.selectedRow.jobNo
      this.rejectWindow.visible = true
    },
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.selectedRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      this.airMblDisplayStyle = Number(cache.config.get('AirMblDisplayStyle')) === 1
    }
  }
}
</script>

<style scoped lang="scss">
#app .grid-view .main-content ::v-deep {
  .button-group {
    min-width: 100%;
  }
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
  }
}
</style>
